export const getAvatarInitials = (name: string): string => {
  const regex = /\b[A-Z|a-z]{1}/g;
  const match = name.match(regex);

  if (match && match.length > 0) {
    return match
      .slice(0, 2)
      .map((c) => c.toUpperCase())
      .join('');
  }

  return '';
};

export const getAvatarBackgroundColor = (name: string): string => {
  const colors = [
    '#e91e63',
    '#9c27b0',
    '#673ab7',
    '#009688',
    '#0097a7',
    '#43a047',
    '#0097a7',
    '#3f51b5',
    '#795548',
    '#ff5722',
  ];

  const charCodeTotal = Array.from(name)
    .map((char) => char.charCodeAt(0))
    .reduce((acc, num) => acc + num, 0);

  const idx = parseInt(charCodeTotal.toString().slice(-1) || '0');

  return colors[idx] || colors[0];
};
